import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useStore } from '../../../app/stores/store';
import { Activity } from '../../../app/models/activity';
import _ from 'lodash';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';

function Shipping() {
    const{activityStore, userStore, dashboardStore}= useStore()
    const [pageNumber, setPageNumber] = useState(1);
    // const [postsPerPage, setPostsPerPage] = useState<number>(5);
    const postsPerPage = 5


    

    useEffect(()=>{
        const pageSize=5
        activityStore.HFCShippingdeliveryloadActivitiesPagination(pageNumber, userStore?.user!.id, pageSize, []) 
     // eslint-disable-next-line
    },[])
  
    const userID = userStore.user?.id !== undefined ? userStore.user?.id : '';
     // eslint-disable-next-line
    const tableData: Activity[] = [];

    activityStore.activitiesByDate?.forEach((a: any) => {
        // isMaster
        delete a?.isMaster;
        // eslint-disable-next-line
        delete a?.sections_Multiple_From;
        delete a?.sections_From;
        delete a?.synopsis;
    
        tableData?.push({
          ...a,
          //  movementdate:userReadableDateFormat(a.movementdate),
          //  movement_Time:userReadableDateFormat(a.movement_Time),
          //  maintenance:userReadableDateFormat(a.maintenance),
          //  receivingdate:userReadableDateFormat(a.receivingdate),
          //  status_Time: userReadableDateFormat(a.status_Time),
          //  itemCreatedAt:userReadableDateFormat(a.itemCreatedAt)
        });
      });
      const createOrderFilter = tableData?.filter((x) => x?.isReceiving === false);
      const MainFilter =
        dashboardStore.dashboard.L2CardValueInventory === 'Receiving' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Create Order Receiving'
          ? createOrderFilter
          : tableData;
    
      const removeCol =
        'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,inactive,isgoing,ishost,clearedon';
      const assettable = JSON.parse(JSON.stringify(MainFilter));
      assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

      const paginateFunction = (e: number) => {
        const resultArray = Object.entries(dashboardStore.dashboard.searchfilterparams).map(([header, searchValue]) => ({
          header,
          searchValue
        }));
        if (
          !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
          Object.values(dashboardStore.dashboard.searchfilterparams).every(
            (o) => o !== '',
          ) &&
          dashboardStore.dashboard.orderData === '' &&
          dashboardStore.dashboard.orderName === ''
        ) {
          activityStore.HFCShippingsearchListItems(resultArray,
            e,
            postsPerPage) 
        } else if (
          dashboardStore.dashboard.orderData !== '' &&
          dashboardStore.dashboard.orderName !== ''
        ) {
          activityStore.sortListItems(
            dashboardStore.dashboard.orderName,
            dashboardStore.dashboard.orderData,
            e,
            postsPerPage,
          ); 
        } else {
          // console.log(e,userID,postsPerPage,[])
          activityStore.HFCShippingdeliveryloadActivitiesPagination (e, userID, postsPerPage);
        }
        dashboardStore.setTagPageNumFunc(e);
        setPageNumber(e);
      };
      const searchFunction = (column: any, order: any) => {
        console.log(order, column);
      };
  return (
    <div>
        <DynamicTableComponent data={assettable} name={'HFCShipper'} actiontype={'Invoice'} pageFunc={paginateFunction} pageNumData={pageNumber} searchFuncData={searchFunction}/>
    </div>
  )
}

export default observer (Shipping)